import React, { useEffect, useState } from "react";
import SuccessModal from "../shared/SuccessModal";
import axios from "axios";
import Breadcrumb from "../Breadcrumb";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    subject: "",
    message: "",
  });
  const [loggedIn, setloggedIn] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    success: false,
    message: ""
  });

  const getUser = async (id) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}users/finduser?id=${id}`;
      // console.log(url);
      const response = await axios.get(url);
      if (response.data && response.data.length == 1) {
        let user = response.data[0];
        setloggedIn(true);
        setFormData((prev) => ({ ...prev, name: user.name, mobile: user.mobile, email: user.email }))
      }
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    const id = localStorage.getItem("userid");
    if (id) {
      getUser(id);
    }
  }, [])


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const url = `${process.env.REACT_APP_API_URL}contact/createcontact`;
      const response = await axios.post(url, formData);
      if (response.status === 201) {
        setModalConfig({
          success: true,
          message: "Message sent successfully!"
        });
      } else {
        setModalConfig({
          success: false,
          message: "Failed to send the message. Please try again."
        });
      }
      setFormData({
        name: "",
        mobile: "",
        email: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      console.error("Error:", error);
      setModalConfig({
        success: false,
        message: "Failed to send the message. Please try again."
      });
    } finally {
      setIsSubmitting(false);
      setShowModal(true);
    }
  };

  return (
    <>
      {/* Breadcrumb Section */}
      {/* <div className="site-breadcrumb">
        <div className="container">
          <h2 className="breadcrumb-title">Contact Us</h2>
          <ul className="breadcrumb-menu">
            <li>
              <a href="index.html">Home</a>
            </li>
            <li className="active">Contact Us</li>
          </ul>
        </div>
        <div className="hero-shape">
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-1" src="assets/img/shape/03.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-2" src="assets/img/shape/05.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-3" src="assets/img/shape/06.svg" alt="" />
          <img 
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high"className="hero-shape-4" src="assets/img/shape/07.svg" alt="" />
        </div>
      </div> */}
      <Breadcrumb
        title="Contact Us"
        path={[
          { label: "Home", href: "/", active: false },
          { label: "Contact Us", active: true }
        ]}
      />
      {/* Contact Section */}
      <div className="contact-section py-5">
        <div className="container">
          <div className="row g-5">
            {/* Contact Form */}
            <div className="col-lg-8">
              <div className="contact-form">
                <h2 className="fs-4 mb-4">
                  Get In Touch
                </h2>
                <p className="fs-5 mb-5">
                  We’d love to hear from you! Whether you have questions, need assistance, or just want to explore opportunities, we’re here to help.
                </p>
                <form onSubmit={handleSubmit}>
                  <div className="row g-4">
                    <div className="col-md-6">
                      <input
                        type="text"
                        className="form-control "
                        name="name"
                        placeholder="Your Name"
                        value={formData.name}
                        onChange={handleChange}
                        readOnly={loggedIn}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        type="tel"
                        className="form-control"
                        name="mobile"
                        placeholder="Your Phone No."
                        value={formData.mobile}
                        onChange={handleChange}
                        readOnly={loggedIn}
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        placeholder="Your Email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        readOnly={loggedIn}
                      />
                    </div>
                    <div className="col-md-6">
                      <input
                        type="text"
                        className="form-control fs-5 px-4 py-2"
                        name="subject"
                        placeholder="Your Subject"
                        value={formData.subject}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-12">
                      <textarea
                        className="form-control fs-5 px-4 py-2"
                        name="message"
                        rows="5"
                        placeholder="Write Your Message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>
                    <div className="col-12">
                      <button
                        type="submit"
                        className="btn btn-primary fs-5 px-4 py-2"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Sending..." : "Send Message"}{" "}
                        <i className="fas fa-paper-plane"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="contact-info">
                <div className="contact-card">
                  <h5>Call Us</h5>
                  <p>
                    <a
                      href="tel:+9195991 71535"
                      className="text-decoration-none text-body"
                    >
                      +9195991 71535
                    </a>
                  </p>
                </div>
              </div>

              <div className="contact-info">
                <div className="contact-card">
                  <h5>Email Us</h5>
                  <p>
                    <a href="mailto:info@hashedbit.com" className="text-decoration-none text-body">
                      info@hashedbit.com
                    </a>

                  </p>
                </div>
              </div>

              <div className="contact-info">
                <div className="contact-card">
                  <h5>Open Time</h5>
                  <p>Monday to Friday, 11:00 AM – 7:00 PM (Closed on Holidays).</p>
                </div>
              </div>
            </div>

            {/* <div className="contact-map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d96708.34194156103!2d-74.03927096447748!3d40.759040329405195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x4a01c8df6fb3cb8!2sSolomon%20R.%20Guggenheim%20Museum!5e0!3m2!1sen!2sbd!4v1619410634508!5m2!1sen!2s"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div> */}
          </div>
        </div>
      </div>
      {/* Modal Component */}
      <SuccessModal
        show={showModal}
        onClose={() => setShowModal(false)}
        success={modalConfig.success}
        message={modalConfig.message} />
    </>
  );
};

export default ContactUs;
